import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from "../../errors/api-error-handler";
import {
  LatestBooksInitialStateType,
  LatestBooksType,
} from "../../models/latest-books-model";
import LatestBooksService from "../../services/latest-books.service";

const initialState: LatestBooksInitialStateType = {
  featuredBooksData: [],
  loading: true,
  error: undefined,
};

export const retrieveLatestBooks = createAsyncThunk(
  "latestBooks/retrieve",
  async (numberOfProducts: number) => {
    const response = await LatestBooksService.getLatestBooks(numberOfProducts);
    return [...response.data.result];
  }
);

const latestBooksSlice = createSlice({
  name: "latestBooks",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(retrieveLatestBooks.pending, (state) => {
        state.loading = true;
      })
      .addCase(retrieveLatestBooks.fulfilled, (state, action) => {
        if (action.payload) {
          state.loading = false;
          state.featuredBooksData = action.payload as LatestBooksType[];
        }
      })
      .addCase(retrieveLatestBooks.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = apiErrorHandler(Number(payload));
      });
  },
});

export const selectAllEntities = (state: { entities: any }) => state.entities;
export default latestBooksSlice.reducer;
